import React from 'react';
import DefaultButton from './DefaultButton';
// import PlusCircleIcon from '../../../../assets/icons/button-icons/PlusCircleIcon';
import PropTypes from 'prop-types';
import { COLORS } from 'app/config/colors';

function AddButton(props) {
  const { size } = props;
  return (
    <DefaultButton
      tag='ADICIONAR'
      // color={COLORS.ACCENTUATED_VARIANT}
      colorHover={COLORS.WHITE_VARIANT}
      // backgroundColor={COLORS.WHITE_VARIANT}
      backgroundColorHover={COLORS.ACCENTUATED_VARIANT_DARK}
      // borderColor={COLORS.ACCENTUATED_VARIANT}
      borderColorHover={COLORS.ACCENTUATED_VARIANT_DARK}
      onClick={props.onClick}
      // icon={<PlusCircleIcon fill={COLORS.ACCENTUATED_VARIANT} />}
      // iconHover={<PlusCircleIcon fill={COLORS.WHITE_VARIANT} />}
      size={size}
    />
  );
}

AddButton.defaultProps = {
  size: 'medium'
};

AddButton.propTypes = {
  onClick: PropTypes.func,
  size: PropTypes.oneOf(['small', 'medium', 'big', 'huge'])
};

export default AddButton;
